/**
 * FlowLayoutRouter — historisch entschied dieser Wrapper pro Request, ob die
 * klassische Sidebar-Shell oder die parallele Flow-UI (Flag `ui_flow_mode`,
 * Flucht via `?view=classic`, `/dashboard → /flow`-Redirect) gerendert wird.
 *
 * Mit der Vereinheitlichung gibt es nur noch EINE Modus-Achse (schlicht/voll,
 * siehe `@/contexts/ModeContext`). Die Sonderbehandlung der Flow-Routen ist
 * damit entfallen: dieser Wrapper rendert jetzt immer die `<Layout>`-Shell.
 * Die guten Flow-Ideen wandern schrittweise in den schlichten Modus; bis
 * dahin bleiben die `/flow*`-Routen erreichbar (sie rendern dann innerhalb
 * der normalen Shell, kein Datenverlust).
 *
 * Wird als transparenter Passthrough beibehalten, damit `AppRoutes` stabil
 * bleibt; kann entfallen, sobald die `/flow*`-Routen migriert/entfernt sind.
 */

import { Layout } from '@/components/Layout';

export function FlowLayoutRouter() {
  return <Layout />;
}
